import { iconSrcs } from '../../generated/manifests/tokenIcons';
import { ChainId, type Token } from '../../types';
import { bnb } from '../nativeTokens';

export const bscMainnet: Token[] = [
  bnb[ChainId.BSC_MAINNET],
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63',
    decimals: 18,
    symbol: 'XVS',
    iconSrc: iconSrcs.xvs,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7',
    decimals: 18,
    symbol: 'VAI',
    iconSrc: iconSrcs.vai,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x5f84ce30dc3cf7909101c69086c50de191895883',
    decimals: 18,
    symbol: 'VRT',
    iconSrc: iconSrcs.vrt,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A',
    decimals: 18,
    symbol: 'SXP',
    iconSrc: iconSrcs.sxp,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    decimals: 18,
    symbol: 'USDC',
    iconSrc: iconSrcs.usdc,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x55d398326f99059fF775485246999027B3197955',
    decimals: 18,
    symbol: 'USDT',
    iconSrc: iconSrcs.usdt,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    decimals: 18,
    symbol: 'BUSD',
    iconSrc: iconSrcs.busd,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    decimals: 18,
    symbol: 'BTCB',
    iconSrc: iconSrcs.btcb,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    decimals: 18,
    symbol: 'ETH',
    iconSrc: iconSrcs.eth,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x4338665CBB7B2485A8855A139b75D5e34AB0DB94',
    decimals: 18,
    symbol: 'LTC',
    iconSrc: iconSrcs.ltc,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE',
    decimals: 18,
    symbol: 'XRP',
    iconSrc: iconSrcs.xrp,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf',
    decimals: 18,
    symbol: 'BCH',
    iconSrc: iconSrcs.bch,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
    decimals: 18,
    symbol: 'DOT',
    iconSrc: iconSrcs.dot,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD',
    decimals: 18,
    symbol: 'LINK',
    iconSrc: iconSrcs.link,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    decimals: 18,
    symbol: 'DAI',
    iconSrc: iconSrcs.dai,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153',
    decimals: 18,
    symbol: 'FIL',
    iconSrc: iconSrcs.fil,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B',
    decimals: 18,
    symbol: 'BETH',
    iconSrc: iconSrcs.beth,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
    decimals: 18,
    symbol: 'ADA',
    iconSrc: iconSrcs.ada,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
    decimals: 8,
    symbol: 'DOGE',
    iconSrc: iconSrcs.doge,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xcc42724c6683b7e57334c4e856f4c9965ed682bd',
    decimals: 18,
    symbol: 'MATIC',
    iconSrc: iconSrcs.matic,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    decimals: 18,
    symbol: 'CAKE',
    iconSrc: iconSrcs.cake,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xfb6115445Bff7b52FeB98650C87f44907E58f802',
    decimals: 18,
    symbol: 'AAVE',
    iconSrc: iconSrcs.aave,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x40af3827F39D0EAcBF4A168f8D4ee67c121D11c9',
    decimals: 18,
    symbol: 'TUSD',
    iconSrc: iconSrcs.tusd,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x14016e85a25aeb13065688cafb43044c2ef86784',
    decimals: 18,
    symbol: 'TUSDOLD',
    iconSrc: iconSrcs.tusd,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xCE7de646e7208a4Ef112cb6ed5038FA6cC6b12e3',
    decimals: 6,
    symbol: 'TRX',
    iconSrc: iconSrcs.trx,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B',
    decimals: 18,
    symbol: 'TRXOLD',
    iconSrc: iconSrcs.trx,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xa2E3356610840701BDf5611a53974510Ae27E2e1',
    decimals: 18,
    symbol: 'WBETH',
    iconSrc: iconSrcs.wbeth,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x0782b6d8c4551B9760e74c0545a9bCD90bdc41E5',
    decimals: 18,
    symbol: 'lisUSD',
    iconSrc: iconSrcs.lisUSD,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xd17479997F34dd9156Deef8F95A52D81D265be9c',
    decimals: 18,
    symbol: 'USDD',
    iconSrc: iconSrcs.usdd,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x352Cb5E19b12FC216548a2677bD0fce83BaE434B',
    decimals: 18,
    symbol: 'BTT',
    iconSrc: iconSrcs.btt,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x20eE7B720f4E4c4FFcB00C4065cdae55271aECCa',
    decimals: 18,
    symbol: 'NFT',
    iconSrc: iconSrcs.nft,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99',
    decimals: 18,
    symbol: 'WIN',
    iconSrc: iconSrcs.win,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x12BB890508c125661E03b09EC06E404bc9289040',
    decimals: 18,
    symbol: 'RACA',
    iconSrc: iconSrcs.raca,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xfb5B838b6cfEEdC2873aB27866079AC55363D37E',
    decimals: 9,
    symbol: 'FLOKI',
    iconSrc: iconSrcs.floki,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xCa3F508B8e4Dd382eE878A314789373D80A5190A',
    decimals: 18,
    symbol: 'BIFI',
    iconSrc: iconSrcs.bifi,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x965F527D9159dCe6288a2219DB51fc6Eef120dD1',
    decimals: 18,
    symbol: 'BSW',
    iconSrc: iconSrcs.bsw,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F',
    decimals: 18,
    symbol: 'ALPACA',
    iconSrc: iconSrcs.alpaca,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xf307910A4c7bbc79691fD374889b36d8531B08e3',
    decimals: 18,
    symbol: 'ANKR',
    iconSrc: iconSrcs.ankr,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x52F24a5e03aee338Da5fd9Df68D2b6FAe1178827',
    decimals: 18,
    symbol: 'ankrBNB',
    iconSrc: iconSrcs.ankrBNB,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275',
    decimals: 18,
    symbol: 'BNBx',
    iconSrc: iconSrcs.bnbx,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xc2E9d07F66A89c44062459A47a0D2Dc038E4fb16',
    decimals: 18,
    symbol: 'stkBNB',
    iconSrc: iconSrcs.stkBNB,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    symbol: 'WBNB',
    iconSrc: iconSrcs.wbnb,
    tokenWrapped: bnb[ChainId.BSC_MAINNET],
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x3BC5AC0dFdC871B365d159f728dd1B9A0B5481E8',
    decimals: 18,
    symbol: 'SD',
    iconSrc: iconSrcs.sd,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x4b0f1812e5df2a09796481ff14017e6005508003',
    decimals: 18,
    symbol: 'TWT',
    iconSrc: iconSrcs.twt,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xF4C8E32EaDEC4BFe97E0F595AdD0f4450a863a11',
    decimals: 18,
    symbol: 'THE',
    iconSrc: iconSrcs.the,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xB0b84D294e0C75A6abe60171b70edEb2EFd14A1B',
    decimals: 18,
    symbol: 'slisBNB',
    iconSrc: iconSrcs.slisBNB,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x12f31b73d812c6bb0d735a218c086d44d5fe5f89',
    decimals: 18,
    symbol: 'EURA',
    iconSrc: iconSrcs.eura,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x97B6897AAd7aBa3861c04C0e6388Fc02AF1F227f',
    decimals: 18,
    symbol: 'ANGLE',
    iconSrc: iconSrcs.angle,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xbf5140a22578168fd562dccf235e5d43a02ce9b1',
    decimals: 18,
    symbol: 'UNI',
    iconSrc: iconSrcs.uni,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xca6d678e74f553f0e59cccc03ae644a3c2c5ee7d',
    decimals: 18,
    symbol: 'PLANET',
    iconSrc: iconSrcs.planet,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409',
    decimals: 18,
    symbol: 'FDUSD',
    iconSrc: iconSrcs.fdusd,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xc748673057861a797275cd8a068abb95a902e8de',
    decimals: 9,
    symbol: 'BabyDoge',
    iconSrc: iconSrcs.babyDoge,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x04c0599ae5a44757c0af6f9ec3b93da8976c150a',
    decimals: 18,
    symbol: 'weETH',
    iconSrc: iconSrcs.weEth,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x26c5e01524d2E6280A48F2c50fF6De7e52E9611C',
    decimals: 18,
    symbol: 'wstETH',
    iconSrc: iconSrcs.wstEth,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x4aae823a6a0b376de6a78e74ecc5b079d38cbcf7',
    decimals: 18,
    symbol: 'solvBTC',
    iconSrc: iconSrcs.solvBtc,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x541B5eEAC7D4434C8f87e2d32019d67611179606',
    decimals: 18,
    symbol: 'PT-SolvBTC.BBN-MAR25',
    iconSrc: iconSrcs.ptSolvBtc,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x570A5D26f7765Ecb712C0924E4De545B89fD43dF',
    decimals: 18,
    symbol: 'SOL',
    iconSrc: iconSrcs.sol,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xe8f1c9804770e11ab73395be54686ad656601e9e',
    decimals: 18,
    symbol: 'PT-clisBNB-APR25',
    iconSrc: iconSrcs.ptClisBNB,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x77734e70b6E88b4d82fE632a168EDf6e700912b6',
    decimals: 18,
    symbol: 'asBNB',
    iconSrc: iconSrcs.asBnb,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xdd809435ba6c9d6903730f923038801781ca66ce',
    decimals: 18,
    symbol: 'PT-sUSDE-JUN2025',
    iconSrc: iconSrcs.ptSUsdE,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34',
    decimals: 18,
    symbol: 'USDe',
    iconSrc: iconSrcs.usde,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
    decimals: 18,
    symbol: 'sUSDe',
    iconSrc: iconSrcs.sUsdE,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d',
    decimals: 18,
    symbol: 'USD1',
    iconSrc: iconSrcs.usd1,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x1346b618dC92810EC74163e4c27004c921D446a5',
    decimals: 18,
    symbol: 'xSolvBTC',
    iconSrc: iconSrcs.xSolvBtc,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x5A110fC00474038f6c02E89C707D638602EA44B5',
    decimals: 18,
    symbol: 'USDF',
    iconSrc: iconSrcs.usdf,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x607c834cfb7fcbbb341cbe23f77a6e83bcf3f55c',
    decimals: 18,
    symbol: 'PT-USDe-30OCT2025',
    iconSrc: iconSrcs.ptUsdE,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x156ab3346823B651294766e23e6Cf87254d68962',
    decimals: 6,
    symbol: 'LUNA',
    iconSrc: iconSrcs.luna,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x3d4350cD54aeF9f9b2C29435e0fa809957B3F30a',
    decimals: 6,
    symbol: 'UST',
    iconSrc: iconSrcs.ust,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xcE24439F2D9C6a2289F741120FE202248B666666',
    decimals: 18,
    symbol: 'U',
    iconSrc: iconSrcs.u,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xe052823b4aefc6e230FAf46231A57d0905E30AE0',
    decimals: 18,
    symbol: 'PT-clisBNBx-25JUN2026',
    iconSrc: iconSrcs.slisBnbX,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x23AE4fd8E7844cdBc97775496eBd0E8248656028',
    decimals: 18,
    symbol: 'XAUm',
    iconSrc: iconSrcs.xaum,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x5b1910eAaD6450E50f816082Aa078C41F10C292f',
    decimals: 18,
    symbol: 'TSLAB',
    iconSrc: iconSrcs.tslab,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x02Fca66C1D1aFB4E2A7884261eB00F63598a7436',
    decimals: 18,
    symbol: 'NVDAB',
    iconSrc: iconSrcs.nvdab,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xbe9D156892E55e7154BcD3cB0FEA677F9D3103E1',
    decimals: 18,
    symbol: 'SPCXB',
    iconSrc: iconSrcs.spcxb,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0xCA750eF65f295BBECd685Abf54e82CAf297BDB61',
    decimals: 18,
    symbol: 'SKHYB',
    iconSrc: iconSrcs.skhyb,
  },
];
